// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.J4fjld {
  margin: 0;
  padding: 0;
  background: var(--surface-neutral-white);
  font-family: var(--font-family-base);
  color: var(--text-neutral-dark);
  letter-spacing: 0;
}

.jvEv4m {
  display: none;
}

.DfFdvN {
  margin-bottom: var(--spacing-2);
}

.DfFdvN:last-child {
  margin-bottom: 0;
}

.Bc3DGb {
  display: flex;
  gap: var(--spacing-2);
}

.SO9Dwy {
  flex: 1;
  min-width: 0;
}

.ddK9OC {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  line-height: 22px;
  color: var(--text-neutral-dark);
  margin-bottom: var(--spacing-0-5);
}

.V7erGT {
  font-size: 15px;
  font-weight: var(--font-weight-regular);
  line-height: 21px;
  color: var(--text-neutral-dark);
  word-break: break-word;
  min-height: 21px;
}

.Oosc8L {
  display: flex;
  align-items: flex-start;
  gap: var(--spacing-1);
  width: 100%;
}

.Oosc8L .V7erGT {
  flex: 0 1 auto;
  min-width: 0;
}

.Z6DgPr {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
}

.Z6DgPr:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.POVQT6 {
  width: 16px;
  height: 16px;
  display: block;
}

.a3_9jZ {
  position: absolute;
  width: 0;
  height: 0;
  overflow: hidden;
  pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/SecureCardViewerPage/SecureCardViewerPage.module.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,wCAAwC;EACxC,oCAAoC;EACpC,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;EACxC,iBAAiB;EACjB,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,uCAAuC;EACvC,iBAAiB;EACjB,+BAA+B;EAC/B,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,oBAAoB;AACtB","sourcesContent":[".root {\n  margin: 0;\n  padding: 0;\n  background: var(--surface-neutral-white);\n  font-family: var(--font-family-base);\n  color: var(--text-neutral-dark);\n  letter-spacing: 0;\n}\n\n.fieldsHidden {\n  display: none;\n}\n\n.field {\n  margin-bottom: var(--spacing-2);\n}\n\n.field:last-child {\n  margin-bottom: 0;\n}\n\n.row {\n  display: flex;\n  gap: var(--spacing-2);\n}\n\n.column {\n  flex: 1;\n  min-width: 0;\n}\n\n.label {\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-semibold);\n  line-height: 22px;\n  color: var(--text-neutral-dark);\n  margin-bottom: var(--spacing-0-5);\n}\n\n.value {\n  font-size: 15px;\n  font-weight: var(--font-weight-regular);\n  line-height: 21px;\n  color: var(--text-neutral-dark);\n  word-break: break-word;\n  min-height: 21px;\n}\n\n.cardNumberRow {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--spacing-1);\n  width: 100%;\n}\n\n.cardNumberRow .value {\n  flex: 0 1 auto;\n  min-width: 0;\n}\n\n.copyButton {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 16px;\n  height: 16px;\n  padding: 0;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n}\n\n.copyButton:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.copyIcon {\n  width: 16px;\n  height: 16px;\n  display: block;\n}\n\n.cardDataHost {\n  position: absolute;\n  width: 0;\n  height: 0;\n  overflow: hidden;\n  pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `J4fjld`,
	"fieldsHidden": `jvEv4m`,
	"field": `DfFdvN`,
	"row": `Bc3DGb`,
	"column": `SO9Dwy`,
	"label": `ddK9OC`,
	"value": `V7erGT`,
	"cardNumberRow": `Oosc8L`,
	"copyButton": `Z6DgPr`,
	"copyIcon": `POVQT6`,
	"cardDataHost": `a3_9jZ`
};
module.exports = ___CSS_LOADER_EXPORT___;
